/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { JsonCompat } from '../../compat/JsonCompat';
import { Node } from '../../core/models/Node';
import { Components } from '../../core/models/common/Components';
import { IVisitor } from '../../core/visitors/IVisitor';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends Components
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiComponents extends Components {
    /**
     * Represents `Map[string, any]`.
     * Objects of `any` type are deserialized as follows:
     * In TypeScript, this field contains the raw JS object, in case of Java
     * it is a {@link com.fasterxml.jackson.databind.node.ObjectNode}.
     * 
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#protocolInfoObject">AsyncAPI 2.0.0 spec</a>
     */
    public schemas : any;

    public messages : any;

    public securitySchemes : any;

    public parameters : any;

    public correlationIds : any;

    public operationTraits : any;

    public messageTraits : any;

    public serverBindings : any;

    public channelBindings : any;

    public operationBindings : any;

    public messageBindings : any;

    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            if(this.schemas===undefined) this.schemas = null;
            if(this.messages===undefined) this.messages = null;
            if(this.securitySchemes===undefined) this.securitySchemes = null;
            if(this.parameters===undefined) this.parameters = null;
            if(this.correlationIds===undefined) this.correlationIds = null;
            if(this.operationTraits===undefined) this.operationTraits = null;
            if(this.messageTraits===undefined) this.messageTraits = null;
            if(this.serverBindings===undefined) this.serverBindings = null;
            if(this.channelBindings===undefined) this.channelBindings = null;
            if(this.operationBindings===undefined) this.operationBindings = null;
            if(this.messageBindings===undefined) this.messageBindings = null;
            if(this.schemas===undefined) this.schemas = null;
            if(this.messages===undefined) this.messages = null;
            if(this.securitySchemes===undefined) this.securitySchemes = null;
            if(this.parameters===undefined) this.parameters = null;
            if(this.correlationIds===undefined) this.correlationIds = null;
            if(this.operationTraits===undefined) this.operationTraits = null;
            if(this.messageTraits===undefined) this.messageTraits = null;
            if(this.serverBindings===undefined) this.serverBindings = null;
            if(this.channelBindings===undefined) this.channelBindings = null;
            if(this.operationBindings===undefined) this.operationBindings = null;
            if(this.messageBindings===undefined) this.messageBindings = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this.schemas===undefined) this.schemas = null;
            if(this.messages===undefined) this.messages = null;
            if(this.securitySchemes===undefined) this.securitySchemes = null;
            if(this.parameters===undefined) this.parameters = null;
            if(this.correlationIds===undefined) this.correlationIds = null;
            if(this.operationTraits===undefined) this.operationTraits = null;
            if(this.messageTraits===undefined) this.messageTraits = null;
            if(this.serverBindings===undefined) this.serverBindings = null;
            if(this.channelBindings===undefined) this.channelBindings = null;
            if(this.operationBindings===undefined) this.operationBindings = null;
            if(this.messageBindings===undefined) this.messageBindings = null;
            if(this.schemas===undefined) this.schemas = null;
            if(this.messages===undefined) this.messages = null;
            if(this.securitySchemes===undefined) this.securitySchemes = null;
            if(this.parameters===undefined) this.parameters = null;
            if(this.correlationIds===undefined) this.correlationIds = null;
            if(this.operationTraits===undefined) this.operationTraits = null;
            if(this.messageTraits===undefined) this.messageTraits = null;
            if(this.serverBindings===undefined) this.serverBindings = null;
            if(this.channelBindings===undefined) this.channelBindings = null;
            if(this.operationBindings===undefined) this.operationBindings = null;
            if(this.messageBindings===undefined) this.messageBindings = null;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAaiVisitor = <IAaiVisitor><any>visitor;
        v.visitComponents(this);
    }

    public getMessagesList() : Array<AaiMessage> {
        return JsonCompat.mapToList<any>(this.messages);
    }

    public getSecuritySchemesList() : Array<AaiSecurityScheme> {
        return JsonCompat.mapToList<any>(this.securitySchemes);
    }

    public getParametersList() : Array<AaiParameter> {
        return JsonCompat.mapToList<any>(this.parameters);
    }

    public getCorrelationIdsList() : Array<AaiCorrelationId> {
        return JsonCompat.mapToList<any>(this.correlationIds);
    }

    public getOperationTraitDefinitionsList() : Array<AaiOperationTraitDefinition> {
        return JsonCompat.mapToList<any>(this.operationTraits);
    }

    public getMessageTraitDefinitionsList() : Array<AaiMessageTraitDefinition> {
        return JsonCompat.mapToList<any>(this.messageTraits);
    }

    public getServerBindingsDefinitionList() : Array<AaiServerBindingsDefinition> {
        return JsonCompat.mapToList<any>(this.serverBindings);
    }

    public getChannelBindingsDefinitionList() : Array<AaiChannelBindingsDefinition> {
        return JsonCompat.mapToList<any>(this.channelBindings);
    }

    public getOperationBindingsDefinitionList() : Array<AaiOperationBindingsDefinition> {
        return JsonCompat.mapToList<any>(this.operationBindings);
    }

    public getMessageBindingsDefinitionList() : Array<AaiMessageBindingsDefinition> {
        return JsonCompat.mapToList<any>(this.messageBindings);
    }

    public addSchema(key : string, value : any) {
        if(this.schemas == null) this.schemas = <any>({});
        /* put */(this.schemas[key] = value);
    }

    public addMessage(key : string, value : AaiMessage) {
        if(this.messages == null) this.messages = <any>({});
        /* put */(this.messages[key] = value);
    }

    public addSecurityScheme(key : string, value : AaiSecurityScheme) {
        if(this.securitySchemes == null) this.securitySchemes = <any>({});
        /* put */(this.securitySchemes[key] = value);
    }

    public addParameter(key : string, value : AaiParameter) {
        if(this.parameters == null) this.parameters = <any>({});
        /* put */(this.parameters[key] = value);
    }

    public addCorrelationId(key : string, value : AaiCorrelationId) {
        if(this.correlationIds == null) this.correlationIds = <any>({});
        /* put */(this.correlationIds[key] = value);
    }

    public addMessageTraitDefinition(key : string, value : AaiMessageTraitDefinition) {
        if(this.messageTraits == null) this.messageTraits = <any>({});
        /* put */(this.messageTraits[key] = value);
    }

    public addOperationTraitDefinition(key : string, value : AaiOperationTraitDefinition) {
        if(this.operationTraits == null) this.operationTraits = <any>({});
        /* put */(this.operationTraits[key] = value);
    }

    public addServerBindingDefinition(key : string, value : AaiServerBindingsDefinition) {
        if(this.serverBindings == null) this.serverBindings = <any>({});
        /* put */(this.serverBindings[key] = value);
    }

    public addChannelBindingDefinition(key : string, value : AaiChannelBindingsDefinition) {
        if(this.channelBindings == null) this.channelBindings = <any>({});
        /* put */(this.channelBindings[key] = value);
    }

    public addOperationBindingDefinition(key : string, value : AaiOperationBindingsDefinition) {
        if(this.operationBindings == null) this.operationBindings = <any>({});
        /* put */(this.operationBindings[key] = value);
    }

    public addMessageBindingDefinition(key : string, value : AaiMessageBindingsDefinition) {
        if(this.messageBindings == null) this.messageBindings = <any>({});
        /* put */(this.messageBindings[key] = value);
    }
}
AaiComponents["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiComponents";
AaiComponents["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];





import { AaiMessageBindingsDefinition } from './AaiMessageBindingsDefinition';


import { AaiOperationBindingsDefinition } from './AaiOperationBindingsDefinition';


import { AaiChannelBindingsDefinition } from './AaiChannelBindingsDefinition';


import { AaiServerBindingsDefinition } from './AaiServerBindingsDefinition';


import { AaiMessageTraitDefinition } from './AaiMessageTraitDefinition';


import { AaiOperationTraitDefinition } from './AaiOperationTraitDefinition';


import { AaiCorrelationId } from './AaiCorrelationId';


import { AaiParameter } from './AaiParameter';


import { AaiSecurityScheme } from './AaiSecurityScheme';


import { AaiMessage } from './AaiMessage';

